import axios from 'axios';

import { API_BASE_URL } from './app-config';

let token = localStorage.getItem('token');

const instance = axios.create({
    baseURL: `${API_BASE_URL}/`,
    headers: {
        'Content-type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    }
});

instance.interceptors.request.use((config) => {
    const currentToken = localStorage.getItem('token');

    if (currentToken) {
        config.headers.Authorization = `Bearer ${currentToken}`;
    } else {
        delete config.headers.Authorization;
    }

    return config;
});

export function updateAuthorizationToken(newToken) {
    token = newToken;

    if (newToken) {
        instance.defaults.headers['Authorization'] = `Bearer ${newToken}`;
        return;
    }

    delete instance.defaults.headers['Authorization'];
}

export default instance;
